import TooltipCustom from "components/Common/TooltipCustom";
import React from "react";
import { useTranslation } from "react-i18next";
import { Card } from "reactstrap";
import IconDownload from "../Icons/IconDownload";

export interface Props {
    info?: any,
    handleActionDownload: (item: any) => void,
    handleActionEdit: (item: any) => void,
    handleConfirmDelete: (item: any) => void
}

const ImageBox = ({
    info = null,
    handleActionDownload,
    handleActionEdit,
    handleConfirmDelete
}: Props) => {

    const { t } = useTranslation();

    const onClickActionDownload = () => {
        handleActionDownload && handleActionDownload(info);
    };

    const onClickActionEdit = () => {
        handleActionEdit && handleActionEdit(info);
    };

    const onClickConfirmDelete = () => {
        handleConfirmDelete && handleConfirmDelete(info);
    };

    const splitTagLong = (_tag: string = '') => {
        if (_tag?.length >= 15) {
            return (String(_tag || '')?.slice(0, 3) + "..." + String(_tag || '')?.slice(-1))
        }
        return _tag;
    };

    return (
        <React.Fragment>
            <Card className="gallery-box mb-1">
                <div className="gallery-container d-flex justify-content-center align-items-center " style={{ height: '100%', textAlign: 'center', backgroundColor: '#eaeaea', borderRadius: '3px' }} >
                    <img className="gallery-img img-fluid mx-auto"
                        style={{ objectPosition: 'center' }}
                        src={info?.thumbnail_url || ''}
                        alt={(info?.tags)?.join(', ') || ''}
                    // loading="lazy"
                    />
                    <div className="gallery-overlay" onClick={(e: any) => onClickActionDownload()}>
                        <div className="w-10 d-flex flex-grow-1 gap-3 align-items-center justify-content-end">
                            <TooltipCustom
                                title={t('Download')}
                                className="d-inline-block vertical-align-middle"
                                style={{ transform: 'translateY(1px)' }}
                            >
                                <button type="button" className="btn btn-sm btn-soft-success edit-item-btn"
                                    onClick={(e: any) => { e.stopPropagation(); onClickActionDownload() }}
                                ><i className="ri-download-fill align-bottom"></i></button>
                            </TooltipCustom>

                            <TooltipCustom
                                title={t('Edit')}
                                className="d-inline-block vertical-align-middle"
                                style={{ transform: 'translateY(1px)' }}
                            >
                                <button type="button" className="btn btn-sm btn-soft-primary edit-item-btn"
                                    onClick={(e: any) => { e.stopPropagation(); onClickActionEdit() }}
                                ><i className="ri-pencil-fill align-bottom"></i></button>
                            </TooltipCustom>

                            <TooltipCustom
                                title={t('Remove')}
                                className="d-inline-block vertical-align-middle"
                                style={{ transform: 'translateY(1px)' }}
                            >
                                <button type="button" className="btn btn-sm btn-soft-danger edit-item-btn"
                                    onClick={(e: any) => { e.stopPropagation(); onClickConfirmDelete() }}
                                ><i className="ri-delete-bin-3-fill align-bottom"></i></button>
                            </TooltipCustom>
                        </div>
                    </div>
                </div>
                <div className="box-content">
                    <div className="d-flex align-items-center mt-1">
                        <div className="badge-wrapper d-flex flex-grow-1 gap-1 text-muted">
                            {(info?.tags || [])?.map((tag: string) => <span className="badge rounded-1 border border-secondary text-secondary fs-12 fw-normal py-1 px-2" key={tag}>#{splitTagLong(tag || '')}</span>)}
                        </div>
                        <div className="flex-shrink-0">
                            <div className="d-flex gap-3">
                                <TooltipCustom
                                    title={t('Total Downloads')}
                                    className="d-inline-block vertical-align-middle"
                                // style={{ transform: 'translateY(1px)' }}
                                ><button type="button" className="btn btn-sm fs-14 btn-link text-body text-decoration-none px-0" style={{ verticalAlign: '-webkit-baseline-middle' }}>
                                        <IconDownload width={19} height={19} /> {info?.total_downloads || 0}
                                    </button>
                                </TooltipCustom>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment >
    );
};

export default React.memo(ImageBox);
